import {svgIconWrapper} from '../svg-icon-wrapper';

import TableRegularPencil from './table-regular-pencil-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <TableRegularPencil {...props} />;
}

SvgComponent.iconName = 'tableRegularPencil';

export const TableRegularPencilIcon = svgIconWrapper(SvgComponent);
